import { render, staticRenderFns } from "./ModalProvider.vue?vue&type=template&id=19e98e52&"
import script from "./ModalProvider.vue?vue&type=script&lang=js&"
export * from "./ModalProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports